<template>
    <div v-if="isLoaded" data-cy="container_mission_transaction_detail_page">
        <div class="max-w-500 mx-auto left-0 right-0 bg-transaction-detail" :style="{ '--bg-transaction-detail-url': 'url(' + imgUrl() + ')' }"></div>
        <div class="max-w-500 mx-auto">
            <TopBarBackImage data-cy="btn_mission_transaction_detail_back" @onClickBack="clickBack()" />
            <!-- <div class="bg-mission-detail-cond"> -->
            <div class="px-4">
                <MissionTransactionItems
                    data-cy="component_mission_transaction_detail_item"
                    :mission="missionItem"
                    :index="index"
                    :isShowButton="false"
                    :isShowAllTitle="true"
                    :isShowStatus="false" />
            </div>
            <TransactionDetailAndCondition
                data-cy="component_mission_transaction_detail_condition"
                :mission="missionItem" />
            <!-- </div> -->
        </div>
    </div>
</template>
<script>
//helper
// import Util from '@/helper/Utility.js';
import ConfigManager from '@/config/ConfigManager.js';
//component
import TopBarBackImage from '@/components/Layout/TopBar/TopBarBackImage.vue';
import TransactionDetailAndCondition from '../component/TransactionDetailAndCondition.vue';
import MissionTransactionItems from '../component/MissionTransaction/MissionTransactionItems.vue';
//mixin
import ModalMixin from '@/mixin/ModalMixin.js';
import AuthPageMixin from '@/mixin/AuthPageMixin.js';
import AuthStatusMixin from '@/mixin/AuthStatusMixin.js';
import LocaleMixin from '@/mixin/LocaleMixin.js';
import ErrorApiMixin from '@/mixin/ErrorApiMixin.js';
//service
import MissionService from '../service/MissionService.js';

export default {
    name: "TransactionDetail",
    mixins: [ModalMixin, AuthPageMixin, AuthStatusMixin, LocaleMixin, ErrorApiMixin],
    components: {
        TopBarBackImage,
        TransactionDetailAndCondition,
        MissionTransactionItems,
    },
    data: function () {
        return {
            isLoaded: false,
            missionId: '',
            missionItem: [],
            textDetail: null,
            type: '',
            index: '',
        };
    },
    created: async function(){
        this.tracking.screenName('mission');

        this.missionId = this.$route.params.missionId;

        await this.getMissionItem();
        this.isLoaded = true;
    },
    methods: {
        getMissionItem: function(){
            return new Promise((resolve) =>{
                MissionService.getMissionTrasaction().subscribe((res) => {
                    console.log('res', res.data)

                    this.missionItem = res.data.filter((item) => item.Id == this.missionId)[0];
                    this.index = parseInt(this.missionItem.Id);
                    console.log('missionItem', this.missionItem)

                    resolve(true);
                }, (err) => {
                    this.errorApi(err);
                    console.log(err);
                    resolve(null);
                });
            })
        },
        clickBack: function() {
            this.$router.back();
        },
        imgUrl: function() {
            var appId = ConfigManager.getAppId();
            return ConfigManager.getBlobUrl()+ `/webconfig/${appId}/images/bg/bg-mission.jpg`;
        },
    }
}
</script>
<style lang="scss" scoped>
@import "@/style/base/base.scss";

.bg-transaction-detail {
    width: 100%;
    height: 100%;
    background-image: var(--bg-transaction-detail-url);
    background-repeat: no-repeat;
    background-size: cover;
    background-position: top center;
    position: fixed;

    @media(max-height: 680px){
        height: 100%;
        background-attachment: fixed;
    }
}
</style>
